import { commonData, SkillResponse } from '@interfaces/hiring-manager.model';
import { FormGroup } from '@angular/forms';
export const getSkillOptions = (skillRes: SkillResponse) => {
  return skillRes.data.skill?.map((item: commonData) => ({
    label: item.name,
    value: item.id,
  }));
};

export function sortArrayByKey<T>(array: T[], key: keyof T): T[] {
  return array.sort((a, b) => {
    const valueA = a[key] as string;
    const valueB = b[key] as string;
    return valueA.localeCompare(valueB);
  });
}
/**
 * This function validates the input value, removes any leading negative sign,
 * limits it to five digits, and updates the form control.
 */

export function validateAndLimitToFiveDigits(event: Event, formGroup: FormGroup, fieldName: string): void {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  if (!isNaN(Number(value)) && value.startsWith('-')) {
    value = value.substring(1);
  }
  if (value?.length > 5) {
    value = value.substring(0, 5);
  }
  formGroup.get(fieldName)?.setValue(value);
}




